
/**
 * 트윗 유형
 */
export type GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
